import {MenuItem, styled} from "@mui/material";

export const OrderPopupActionMenuItem = styled(MenuItem)(() => ({
    display: 'flex',
    justifyContent: 'flex-start',
    gap: '0.5rem',
}))